import React from 'react';
import { toast } from 'sonner';
import { ToastMessage, type ToastVariant } from './ToastMessage';

interface ToastOptions {
  details?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

const triggerToast = (message: string, variant: ToastVariant, options?: ToastOptions) => {
  toast.custom((t) =>
    React.createElement(ToastMessage, {
      id: t,
      variant: variant,
      message: message,
      details: options?.details,
      action: options?.action
    })
  );
};

export const showToast = {
  success: (message: string, options?: ToastOptions) => triggerToast(message, 'success', options),
  error: (message: string, options?: ToastOptions) => triggerToast(message, 'alert', options), // Mapping error -> alert for variant matching
  warning: (message: string, options?: ToastOptions) => triggerToast(message, 'warning', options),
  info: (message: string, options?: ToastOptions) => triggerToast(message, 'info', options)
};
